import React from "react";

function ReferralCard() {
  return (
    <div
      className="p-4 rounded-3"
      style={{
        background: "linear-gradient(90deg, #18181b 0%, #23272f85 100%)",
        border: "1px solid #23272f",
        color: "#fff",
      }}
    >
      <div className="rounded-lg shadow-sm overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 border-bottom border-gray-700">
          <h5 className="text-lg font-medium text-white">
            Slavic401k Retirement Plan
          </h5>
        </div>

        {/* Account Balance Section */}
        <div className="px-6 py-4">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <span className="text-sm text-secondary">Account Balance</span>
            <button className="d-flex align-items-center text-sm text-secondary btn btn-link p-0">
              Hide
              <svg
                className="ms-1"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
          </div>

          <div className="mb-1">
            <span className="h3 fw-bold text-white">$7,253.72</span>
          </div>

          <div className="d-flex align-items-center text-sm text-secondary">
            <span>$6,003.72 Vested</span>
            <svg
              className="ms-1"
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>

        {/* Investment Breakdown */}
        <div className="px-6 py-4 border-top border-gray-700">
          <div className="row text-center">
            {/* Circular Chart */}
            <div className="col-auto">
                  <div className="position-relative">
                    <div 
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: '50px',
                        height: '50px',
                        background: 'conic-gradient(from 0deg, #3B82F6 0deg, #8B5CF6 90deg, #F59E0B 180deg, #10B981 270deg, #EF4444 360deg)'
                      }}
                    >
                      <div 
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#FFFFFF'
                        }}
                      >
                        
                      </div>
                    </div>
                  </div>
                </div>

            {/* Federal */}
            <div className="col">
              <div className="d-flex justify-content-center mb-2">
                <div
                  className="rounded-circle"
                  style={{
                    width: "12px",
                    height: "12px",
                    background: "#22c55e",
                  }}
                ></div>
              </div>
              <div className="text-xs text-secondary mb-1">FEDERAL</div>
              <div className="fw-medium text-white fw-bold">$5,000.00</div>
            </div>

            {/* Roth */}
            <div className="col">
              <div className="d-flex justify-content-center mb-2">
                <div
                  className="rounded-circle"
                  style={{
                    width: "12px",
                    height: "12px",
                    background: "#3b82f6",
                  }}
                ></div>
              </div>
              <div className="text-xs text-secondary mb-1">ROTH</div>
              <div className="fw-medium text-white fw-bold">$2,000.00</div>
            </div>

            {/* Rollover */}
            <div className="col">
              <div className="d-flex justify-content-center mb-2">
                <div
                  className="rounded-circle"
                  style={{
                    width: "12px",
                    height: "12px",
                    background: "#f97316",
                  }}
                ></div>
              </div>
              <div className="text-xs text-secondary mb-1">ROLLOVER</div>
              <div className="fw-medium text-white fw-bold">$253.72</div>
            </div>
          </div>
        </div>

        {/* Additional Info Section */}
        <div className="px-6 py-4 border-top border-gray-700">
          {/* Loan Balance */}
          <div className="d-flex align-items-center mb-4">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center me-3"
              style={{
                width: "24px",
                height: "24px",
                background: "#facc15",
              }}
            >
              <div
                style={{
                  width: "8px",
                  height: "8px",
                  background: "#fff",
                  borderRadius: "50%",
                }}
              ></div>
            </div>
            <div className="flex-grow-1">
              <div className="text-xs text-secondary mb-1">LOAN BALANCE</div>
              <div className="fw-medium text-white">$1,203.12</div>
            </div>
          </div>

          {/* Rate of Return */}
          <div className="d-flex align-items-center">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center me-3"
              style={{
                width: "24px",
                height: "24px",
                background: "#22c55e",
              }}
            >
              <span className="text-white small fw-bold">%</span>
            </div>
            <div className="flex-grow-1">
              <div className="text-xs text-secondary mb-1">
                RATE OF RETURN (1 MONTH)
              </div>
              <div className="fw-medium text-white">1.87%</div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-top border-gray-700">
          <button className="text-white text-sm fw-medium btn btn-link p-0 d-flex align-items-center">
            Visit your 401k portal
            <svg
              className="ms-1"
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReferralCard;
